import { render, staticRenderFns } from "./AddSceneMaterial.vue?vue&type=template&id=26e12faa&scoped=true&"
import script from "./AddSceneMaterial.vue?vue&type=script&lang=js&"
export * from "./AddSceneMaterial.vue?vue&type=script&lang=js&"
import style0 from "./AddSceneMaterial.vue?vue&type=style&index=0&id=26e12faa&prod&scoped=true&lang=css&"
import style1 from "./AddSceneMaterial.vue?vue&type=style&index=1&id=26e12faa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e12faa",
  null
  
)

export default component.exports